export const parseSessionIdFromUrl = () => {
  const pageURL = window.location.href.split("?")[0].split("?")[0];
  const lastSlashIndex = pageURL.lastIndexOf("/");
  const lastURLSegment = pageURL.substring(
    lastSlashIndex + 1,
    lastSlashIndex + 37
  );
  return lastURLSegment;
};
